import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../api/client";

// GET /api/v1/headquarters/ → sedes de la academia (lectura para miembros).
// El docente las necesita para elegir dónde dictar la clase.
function useSedes() {
  return useQuery({
    queryKey: ["headquarters"],
    queryFn: () => apiClient.get("/api/v1/headquarters/").then((r) => r.data),
  });
}

export { useSedes };
